<template>
    <div id="tag" v-if="data.name">
        <a :href="data.url">{{ data.name | capitalize }}</a>
    </div>
</template>

<script>
    export default {
        name: 'Tag',
        props: ['data'],
    }
</script>

<style lang="scss">
    @import '~@/absctracts/variables.scss';

    #tag {
        display: inline;

        a {
            border: 1px solid #dedede;
            display: inline;
            list-style: none;
            padding: 2px 6px;
            margin-right: 5px;
            text-align: center;
            font-size: 12px;
            color: #1c1c1c;
            text-transform: capitalize;
        }

        a:hover {
            background-color: $black;
            color: $white;
        }
    }
</style>